<div class="downloads-available-wrapper">
  @if (gettingDownloads) {
    <ebs-spinner [spinnerMessage]="'loading downloads'"></ebs-spinner>
  }
  <!-- <small class="float-right text-info" *ngIf="canCheckStorage"><b>{{estimate - usage | number:'1.0-0' }}</b> MB of
  storage space
available</small> -->
@if (!gettingDownloads) {
  <div class="table-responsive" style="overflow-x: visible">
    <table class="table">
      <thead>
        <tr>
          <th>Module</th>
          <th>Content</th>
          @if (enableVideoDownload()) {
            <th>Videos</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (courseModule of avilableModuleDownloads; track courseModule) {
<tr [ngStyle]="{'box-shadow': isCurrentlyBeingDownloadedOrDeleted(courseModule) ? '1px 1px 6px 3px #e7e7e7' : 'none',
          'opacity' : turnOffTheOtherRows(courseModule) ? '0.3' : '1' }">
            <td style="width: 50%">
              @if (courseModule.isContentDownloaded) {
                <i class="fas fa-check-circle fa-lg text-success" style="text-align: center; "
                title="module already downloaded"></i>
              }
              @if (!courseModule.isContentDownloaded) {
                <i class="far fa-circle fa-lg" style="color: #d7d7d7;text-align: center; " title="module not downloaded"
                ></i>
              }
              &nbsp; {{courseModule.number }} - {{courseModule.name }} {{isUpdateAvailable(courseModule)}}
            </td>
            <td>
              <!--CONTENT ONLY-->
              @if (weHaveEnoughSpaceToShowContent(courseModule)) {
                <div class="d-flex flex-row">
                  @if (notCurrentlyBeingDeletedOrDownloaded(courseModule) && courseModule.standardContentSize > 0.99) {
                    <div
                      >
                      {{courseModule.standardContentSize | number:'1.0-0'}} MB
                    </div>
                  }
                  @if (notCurrentlyBeingDeletedOrDownloaded(courseModule) && courseModule.standardContentSize <= 0.99) {
                    <div
                      >
                      &#60; 1 MB
                    </div>
                  }
                  @if (showIcons(courseModule)) {
                    <div>
                      @if (!courseModule.isContentDownloaded) {
                        <span role="button"
                          (click)="downloadModule(courseModule, false)" class="pl-1">
                          @if (!gettingDownloads) {
                            <i class="fal fa-download fa-fw fa-lg link" title="download module without videos"
                            ></i>
                          }
                        </span>
                      }
                      @if (courseModule.isContentDownloaded) {
                        <span role="button" (click)="removeModule(courseModule, false)"
                          class="pl-1">
                          <i class="fal fa-trash-alt fa-fw fa-lg link" title="delete module without videos"></i>
                        </span>
                      }
                    </div>
                  }
                  @if (isCurrentlyBeingDownloadedOrDeleted(courseModule)) {
                    <div class="col-12 progress-col">
                      @if (showDownloadProgressContent(courseModule)) {
                        <span class="float-left pr-2 d-none .d-sm-block"><i
                        class="fal fa-download" [@flasher]="flashing"></i></span>
                      }
                      @if (showDeleteProgressContent(courseModule)) {
                        <span class="float-left pr-2 d-none .d-sm-block"><i
                        class="far fa-trash-alt" [@flasher]="flashing"></i></span>
                      }
                      @if (showDownloadProgressContent(courseModule)) {
                        <div class="d-flex flex-row">
                          <ebs-progress-bar [progressMax]="courseModule.monitor.getTotalSize()"
                            [progressValue]="courseModule.monitor.getDownloadedSize()" [progressWrapperWidth]="'100%'">
                          </ebs-progress-bar>
                          <small class="font-weight-bold pl-2">
                            &nbsp;{{courseModule.monitor.getDownloadedSize() / courseModule.monitor.getTotalSize() * 100  | number:'1.0-0' }}
                          %</small>
                        </div>
                      }
                      @if (showDeleteProgressContent(courseModule)) {
                        <div class="d-flex flex-row">
                          <ebs-progress-bar [progressMax]="courseModule.deleteMonitor.getTotal()"
                            [progressValue]="courseModule.deleteMonitor.getTotal() - courseModule.deleteMonitor.getDeletionProgress()"
                          [progressWrapperWidth]="'100%'"></ebs-progress-bar>
                          <small class="font-weight-bold pl-2">
                            {{((courseModule.deleteMonitor.getTotal() - courseModule.deleteMonitor.getDeletionProgress())
                          / courseModule.deleteMonitor.getTotal())  * 100  | number:'1.0-0' }} % </small>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
              @if (canCheckStorage && isItTooBig(courseModule.standardContentSize) && !courseModule.isContentDownloaded) {
                <div class="row"
                  >
                  <div class="col-12"> {{courseModule.standardContentSize | number:'1.0-0'}} MB </div>
                  <small class="text-info">
                    <div class="col-12 text-warning">
                      <i class="fas fa-exclamation-triangle"></i> Not enough space
                    </div>
                  </small>
                </div>
              }
            </td>
            @if (enableVideoDownload()) {
              <td>
                <!--VIDEO-->
                @if (weHaveEnoughSpaceToShowVideo(courseModule) && !isItIos) {
                  <div class="d-flex flex-row size-row-content"
                    >
                    @if (notCurrentlyBeingDeletedOrDownloaded(courseModule) && courseModule.totalContentSize > 0.99) {
                      <div>
                        {{(courseModule.totalContentSize) | number:'1.0-0'}} MB
                      </div>
                    }
                    @if (notCurrentlyBeingDeletedOrDownloaded(courseModule) && courseModule.totalContentSize <= 0.99) {
                      <div>
                        &#60; 1 MB
                      </div>
                    }
                    @if (showIcons(courseModule)) {
                      <div>
                        @if (!courseModule.isVideoListDownloaded && courseModule.isContentDownloaded) {
                          <span role="button"
                            (click)="downloadVideoModule(courseModule, true)" class="pl-1">
                            @if (!gettingDownloads) {
                              <i class="fal fa-download fa-fw fa-lg link" title="download module with videos"
                              ></i>
                            }
                          </span>
                        }
                        @if (courseModule.isVideoListDownloaded) {
                          <span role="button"
                            (click)="removeModule(courseModule, true)" class="pl-1">
                            <i class="fal fa-trash-alt fa-fw fa-lg link" title="delete module with videos"></i>
                          </span>
                        }
                      </div>
                    }
                    @if (isCurrentlyBeingDownloadedOrDeleted(courseModule)) {
                      <div class="col-12 progress-col">
                        @if (showDownloadProgressVideos(courseModule)) {
                          <span class="float-left pr-2 d-none .d-sm-block"><i
                          class="fal fa-download" [@flasher]="flashing"></i></span>
                        }
                        @if (showDeleteProgressVideos(courseModule)) {
                          <span class="float-left pr-2 d-none .d-sm-block"><i
                          class="far fa-trash-alt" [@flasher]="flashing"></i></span>
                        }
                        @if (showDownloadProgressVideos(courseModule)) {
                          <div class="d-flex flex-row progress-row-content">
                            <ebs-progress-bar [progressMax]="courseModule.monitor.getVideoTotalSize()"
                              [progressValue]="courseModule.monitor.getVideoDownloadedSize()" [progressWrapperWidth]="'100%'">
                            </ebs-progress-bar>
                            <small class="font-weight-bold pl-2">
                            {{(courseModule.monitor.getVideoDownloadedSize() / courseModule.monitor.getVideoTotalSize()) * 100  | number:'1.0-0'}}%</small>
                          </div>
                        }
                        @if (showDeleteProgressVideos(courseModule)) {
                          <div class="d-flex flex-row progress-row-content">
                            <ebs-progress-bar [progressMax]="courseModule.deleteMonitor.getTotal()"
                              [progressValue]="courseModule.deleteMonitor.getTotal() - courseModule.deleteMonitor.getDeletionProgress()"
                            [progressWrapperWidth]="'100%'"></ebs-progress-bar>
                            <small class="font-weight-bold pl-2">
                              {{((courseModule.deleteMonitor.getTotal() - courseModule.deleteMonitor.getDeletionProgress()) / courseModule.deleteMonitor.getTotal()) * 100  | number:'1.0-0'}}%
                            </small>
                          </div>
                        }
                        @if (checkIfModuleDownoadMayBeTakingTooLong(courseModule)) {
                          <div class="text-warning">
                            <i class="far fa-fw fa-exclamation-circle"></i>
                            Your download is taking longer than expected
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
                @if (canCheckStorage && isItTooBig(courseModule.totalContentSize) && !courseModule.isVideoListDownloaded && !isItIos) {
                  <div class="row"
                    >
                    <div class="col-12">{{(courseModule.totalContentSize) | number:'1.0-0'}} MB </div>
                    <small class="text-info">
                      <div class="col-12 text-warning">
                        <i class="fas fa-exclamation-triangle"></i> Not enough space
                      </div>
                    </small>
                  </div>
                }
                @if (isItIos) {
                  <div>
                    <small class="text-info">
                      <div class="col-12 text-info">
                        <i class="fas fa-road fa-lg fa-fw"></i> Coming soon
                      </div>
                    </small>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
}
@if (downloadsError) {
  <ebs-notification-multiple [notifications]="notifications"> </ebs-notification-multiple>
}
</div>